import React from 'react'
import getTempUserShortId from '../utils/getTempUserId'
import { upsertPostUser } from '../services/upsertPostUser'
import env from '../configs/env'

export default ({
	imgId,
	postId,
	imgIdClicked,
	setImgIdClicked,
	imgIdFavorite,
	setImgIdFavorite,
	organizationShortId,
	width,
	height,
}: {
	imgId: string
	postId: string
	imgIdClicked: string | undefined
	setImgIdClicked: (imgId: string | undefined) => void
	imgIdFavorite: string | undefined
	setImgIdFavorite: (imgId: string | undefined) => void
	organizationShortId: string
	width: number
	height: number
}) => {
	return (
		<div className={`grid-item flip-card`}>
			<div
				className={`flip-card-inner ${imgId == imgIdClicked ? 'flipped' : ''}`}
				onClick={() => {
					setImgIdClicked(imgId == imgIdClicked ? undefined : imgId)
				}}
			>
				<img
					className="flip-card-front"
					src={
						imgId
							? `https://t44-post-cover.s3.eu-central-1.amazonaws.com/${imgId}`
							: 'http://via.placeholder.com/800x600'
					}
					width={width}
					height={height}
				/>
				<div className="flip-card-back">
					<a
						className="btn btn-xs full-width-sm"
						onClick={(e) => {
							e.preventDefault()
							upsertPostUser(
								{
									postId: postId,
									tempUserShortId: getTempUserShortId(),
									imgId,
									organizationShortId,
								},
								env
							)
							setImgIdFavorite(imgId)
						}}
						style={{ padding: '0 4px 0' }}
					>
						{imgIdFavorite == imgId ? 'A kedvencem' : 'Őt választom'}
					</a>
				</div>
			</div>
		</div>
	)
}
